/* 
we are attempting to deprecate the use of this file; 
please use styled svg instead
*/

import styled from "styled-components";
import PropTypes from "prop-types";

const IconTypeToFile = {
    trash: require("../../../img/icons/trashcan.svg"),
    "angle-up": require("../../../img/icons/angle-up.svg"),
    "angle-down": require("../../../img/icons/angle-down.svg"),
    "angle-left": require("../../../img/icons/angle-up.svg"),
    "angle-right": require("../../../img/icons/angle-up.svg"),
    close: require("../../../img/icons/close.svg"),
    "np-logo": require("../../../img/icons/np-logo.svg"),
    tag: require("../../../img/icons/tag.svg"),
    important: require("../../../img/icons/important.svg"),
    camera: require("../../../img/icons/camera.svg"),
    spinner: require("../../../img/icons/spinner.svg"),
    upload: require("../../../img/icons/upload.svg"),
    "heart-outline": require("../../../img/icons/heart-outline.svg"),
    "heart-filled": require("../../../img/icons/heart-filled.svg"),
    "check-mark-approve-green": require("../../../img/icons/check-mark-approve-green.svg"),
    "arrow-long-right": require("../../../img/icons/arrow-long-right.svg"),
    "check-mark-approve-white": require("../../../img/icons/check-mark-approve-white.svg"),
    "facebook-white": require("../../../img/icons/facebook-white.svg"),
    "twitter-white": require("../../../img/icons/twitter-white.svg"),
};

export const Icon = styled.div`
    display: inline-block;
    height: ${(props) => props.height || "17px"};
    width: ${(props) => props.width || "17px"};
    background-size: cover;
    ${(p) => (p.interactive ? { cursor: "pointer" } : "")}
    ${(p) => {
        if (IconTypeToFile[p.type]) {
            return {
                backgroundImage: `url(${IconTypeToFile[p.type]})`,
            };
        } else {
            return {
                backgroundColor: "#000000",
            };
        }
    }}
    ${(p) => {
        switch (p.type) {
            case "angle-left":
                return {
                    transform: "rotate(-90deg)",
                };
            case "angle-right":
                return {
                    transform: "rotate(90deg)",
                };
        }
    }}
`;

Icon.propTypes = {
    type: PropTypes.string,
    interactive: PropTypes.bool,
    height: PropTypes.string,
    width: PropTypes.string,
};
